import { CohortEnumSchema } from '@eigtech/auth0-types';
import { PublicationTargetsSchema } from '@eigtech/documents-types';
import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const PublishScreenshotsRequestBodySchema = z.object({
    publishTo: PublicationTargetsSchema.array(),
    dateAdded: z.array(z.string().datetime()).min(1).max(500),
    userCohorts: CohortEnumSchema.array().optional(),
});
export const PublishScreenshotsRequestPathSchema = z.object({
    entityId: CornSchema,
    startTime: z.string(),
});
export const PublishScreenshotsRequestHeaderSchema = ApiLambdalerAuthHeaderWithRequestActorSchema;
export const PublishScreenshotsRequestSchema = PublishScreenshotsRequestPathSchema.merge(PublishScreenshotsRequestHeaderSchema).merge(PublishScreenshotsRequestBodySchema);
